import * as _ from "lodash";
import type { IWidget } from "../widget-types/types";
import type { IDataFetcherFactory } from "./IDataFetcher";
import { ReduxStateAwareDataFetcher } from "./ReduxStateAwareDataFetcher";
import { DEFAULT_POPULAR_PAGES_RADIO_FILTER, radioItems } from "../../React/PopularPagesFilters/popularPagesFilters.config";

class PopularPagesDataFetcher<T> extends ReduxStateAwareDataFetcher<T> {
    constructor(widget, statePath) {
        super(widget, statePath);
    }

    fetch(params = this.widget.apiParams) {
        type IWidgetWithMutators = IWidget<T> & {
            updateApiParams(paramsToAdd: any): void;
            clearApiParams(paramsToDelete: any): void;
        };
        const widget = this.widget as IWidgetWithMutators;
        const { checkboxIsSelected, selectedFilter } = this.reduxService.getStatePath(this.statePath);
        const paramsToClear: any = _.map(radioItems, "value");
        const apiRadioFilter =
            _.filter(Object.keys(params), (param) => {
                return paramsToClear.indexOf(param) !== -1;
            })[0] || DEFAULT_POPULAR_PAGES_RADIO_FILTER;

        paramsToClear.push("isUtm");

        widget.clearApiParams(paramsToClear);
        params = widget.apiParams;

        if (apiRadioFilter !== selectedFilter) {
            // the filter changed
            if (selectedFilter === "isTrending") {
                params = {
                    ...params,
                    orderBy: "ChangeInShare desc",
                };
            } else {
                params = {
                    ...params,
                    orderBy: "Share desc", // back to default
                };
            }
        }

        params = {
            ...params,
            [selectedFilter]: true,
        };
        if (checkboxIsSelected) {
            params = {
                ...params,
                isUtm: true,
            };
        }

        widget.updateApiParams(params);
        return super.fetch(params);
    }
}

const PopularPagesDataFetcherFactory: IDataFetcherFactory<any> = {
    create: function (widget: IWidget, { statePath }) {
        return new PopularPagesDataFetcher<any>(widget, statePath);
    },
};

export default PopularPagesDataFetcherFactory;
